// extracted by mini-css-extract-plugin
export var parcelRow = "_ri-0";